/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

type Props = WidgetProps;

export interface StaticPageContainerStyles {
    container?: InjectableCss;
    search?: InjectableCss;
    createButton?: InjectableCss;
}

const styles: StaticPageContainerStyles = {
    container: {
        css: css`
            & div[data-test-selector^="productCarousel"] {
                button[data-test-selector^="prevBtn"] {
                    left: -15px;
                }
                button[data-test-selector^="nextBtn"] {
                    right: -15px;
                }
            }
            & .categoryTitle {
                display: none;
            }

            & div[class^="GridItemStyle"] {
                margin-bottom: 30px;
            }
            & div[data-test-selector^="productCarousel_crossSells"] {
                margin-bottom: 30px;
                div[class^="GridItemStyle"] {
                    margin-bottom: 0;
                }
            }

            & .supplierPage ol {
                padding-left: 20px;
            }
            & .Policy {
                margin: 25px 10px 10px 10px;
                background: whitesmoke;
                padding: 5px;
                box-sizing: border-box;
                .PolicyTitle {
                    color: #0000ff;
                    p {
                        font-weight: 700;
                    }
                }
                p {
                    font-size: 18px;
                    line-height: 30px;
                    margin: 15px;
                }
            }
            & #CareerListing {
                height: 800px;
                width: 100%;
                iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
            }
            .CareersDesc {
                p {
                    font-size: 18px;
                    line-height: 30px;
                    margin: 15px;
                }
            }

            .LocationsSubtitle {
                font-size: 18px;
                line-height: 30px;
                text-align: center;
                background: whitesmoke;
                padding: 12px 5px;
                margin: 15px 10px !important;
            }
            #LocationsWrapper {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
            }

            .LocationsBlockWrapper {
                display: inline-block;
                width: 33%;
                text-align: center;
                margin: 35px 0px;
                vertical-align: top;
                box-sizing: border-box;
                padding: 0px 10px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 50%;
                        `,
                        css`
                            width: 50%;
                        `,
                        null,
                    ])}
            }
            .LocationsBlockWrapper iframe {
                width: 100%;
                min-height: 220px;
            }
            .LocationsBlock {
                padding-bottom: 10px;
                border: 6px solid whitesmoke;
                background: #fffdfd;
                margin-top: 10px;
            }
            .LocationsBlock h2 {
                margin: 15px;
                font-size: 1.5em;
            }
            .ServicesWrapper {
                h3,
                p {
                    font-size: 18px;
                    line-height: 30px;
                    margin: 15px;
                }
            }
            .ExecTeamWrapper {
                width: 100%;
                text-align: center;
                margin-bottom: 45px;
                padding: 15px;
                box-sizing: border-box;
            }
            .Exec {
                display: inline-block;
                width: 100%;
                background-color: #f5f5f5;
                background: rgb(245, 245, 245);
                background: linear-gradient(145deg, rgba(245, 245, 245, 1) 0%, rgb(202, 200, 200) 100%);
                border-bottom: 6px solid #c7c7c7;
                padding: 15px 10px 30px 10px;
                box-sizing: border-box;
                margin-bottom: 30px;
                vertical-align: top;
            }
            .ExecImage {
                width: 28%;
                display: inline-block;
                vertical-align: top;
                margin-top: 18px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: block;
                            width: 100%;
                            margin-bottom: 18px;
                        `,
                        css`
                            display: block;
                            width: 100%;
                            margin-bottom: 18px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .ExecDesc {
                width: 65%;
                display: inline-block;
                text-align: left;
                line-height: 18px;
                border-left: 1px solid #e4e4e4;
                padding-left: 10px;
                box-sizing: border-box;
                box-shadow: inset 3px 0 7px -7px rgba(0, 0, 0, 0.4);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-left: none;
                            width: 100%;
                            padding-left: 0px;
                            border-top: 1px solid #e4e4e4;
                            box-shadow: inset -1px 3px 7px -7px rgba(0, 0, 0, 0.4);
                            padding-top: 10px;
                        `,
                        css`
                            border-left: none;
                            width: 100%;
                            padding-left: 0px;
                            border-top: 1px solid #e4e4e4;
                            box-shadow: inset -1px 3px 7px -7px rgba(0, 0, 0, 0.4);
                            padding-top: 10px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .ExecDesc h2 {
                margin: 0px 15px;
                margin-top: 15px;
                font-size: 21px;
                line-height: 30px;
            }
            .AccomplishmentSection {
                display: inline-block;
                vertical-align: top;
                width: 45%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: block;
                            width: 100%;
                        `,
                        css`
                            display: block;
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .AccomplishmentSection p {
                text-decoration: underline;
            }
            .ExecDesc ul {
                list-style: none;
            }
            .ServicesWrapper li {
                line-height: 30px;
                font-size: 18px;
            }
            .BranchWrapper {
                text-align: center;
                margin-bottom: 35px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                margin-top: 20px;
            }
            .Branch {
                display: inline-block;
                width: 32%;
                background-color: #f5f5f5;
                background: linear-gradient(145deg, rgba(245, 245, 245, 1) 0%, rgb(226, 226, 226) 100%);
                margin-bottom: 20px;
                text-align: center;
                min-height: 210px;
                vertical-align: top;
                border-bottom: 6px solid #c7c7c7;
                flex: none;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 96%;
                            min-height: 330px;
                        `,
                        css`
                            width: 96%;
                            min-height: 330px;
                        `,
                        css`
                            width: 48%;
                            min-height: 210px;
                        `,
                        css`
                            width: 48%;
                            min-height: 210px;
                        `,
                        null,
                    ])}
            }
            .BranchImage {
                width: 30%;
                display: inline-block;
                vertical-align: top;
                margin-top: 18px;
                margin-left: 5px;
                border-right: 1px solid #e4e4e4;
                box-shadow: 3px 0 7px -7px rgba(0, 0, 0, 0.4);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: block;
                            margin: 18px auto;
                            border-right: none;
                            box-shadow: none;
                        `,
                        css`
                            display: block;
                            margin: 18px auto;
                            border-right: none;
                            box-shadow: none;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .BranchImage img {
                height: 160px;
                max-width: 114px;
            }
            .BranchDesc {
                width: 65%;
                display: inline-block;
                line-height: 18px;
                width: 67%;
                margin-top: 22px;
                display: inline-block;
                text-align: left;
                line-height: 18px;
                padding-left: 10px;
                box-sizing: border-box;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-top: 1px solid #e4e4e4;
                            box-shadow: inset 0px 3px 7px -7px rgba(0, 0, 0, 0.4);
                            width: 90%;
                            text-align: center;
                            margin-bottom: 22px;
                        `,
                        css`
                            border-top: 1px solid #e4e4e4;
                            box-shadow: inset 0px 3px 7px -7px rgba(0, 0, 0, 0.4);
                            width: 90%;
                            text-align: center;
                            margin-bottom: 22px;
                        `,
                        null,
                        null,
                        null,
                    ])}

                h2 {
                    font-size: 21px;
                    margin: 15px;
                }
                p {
                    font-size: 17px;
                }
            }
            .CompanyDivision {
                padding: 20px;
                margin: 20px 0;
            }
            .ValuesWrapper {
                text-align: center;
            }
            .ValuesBlockWrapper {
                width: 30%;
                display: inline-block;
                text-align: center;
                padding: 0px 10px 20px 10px;
                box-sizing: border-box;
                min-height: 326px;
                vertical-align: top;
                p,
                h3 {
                    font-size: 18px;
                    line-height: 30px;
                    margin: 15px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .ValuesImage {
                min-height: 140px;
                position: relative;
                padding-bottom: 10px;
            }
            .ValuesTitle {
                color: #0000fe;
                font-size: 20px !important;
                margin: 0px;
                padding: 0px;
                margin-bottom: 15px;
                border-bottom: 2px solid #91a3a5;
                padding: 11px 10px;
                width: 90%;
                margin: 15px auto !important;
            }
            .TechList {
                width: 47%;
                display: inline-block;
                vertical-align: top;
                padding: 10px;
                box-sizing: border-box;
                line-height: 30px;
                font-size: 18px;
                padding-left: 0;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                    ])}
            }
            .dcs {
                .DCSHeader {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                .Title {
                    text-align: center;
                    color: #ffffff;
                    font-weight: bold;
                    margin: 0;
                    padding: 10px;
                    background: #b1b1b1;
                    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);
                    line-height: 40px;
                    font-size: 30px;
                    margin-top: -10px;
                }
                .ServicesWrapper {
                    margin-top: 40px;
                }
                .DCSBlock {
                    display: inline-block;
                    width: 33%;
                    text-align: center;
                    vertical-align: middle;
                    min-height: 200px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            css`
                                width: 100%;
                            `,
                            null,
                            null,
                        ])}
                    span.DCSTop {
                        line-height: 30px;
                        display: block;
                        font-size: 28px;
                    }
                    span.DCSNumberLg {
                        display: block;
                        color: #0000ff;
                        font-weight: bold;
                        font-size: 70px;
                        line-height: 90px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 50px;
                                `,
                                css`
                                    font-size: 50px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    span.DCSBottom {
                        font-size: 28px;
                        line-height: 30px;
                    }
                }
                #TestimonialSection {
                    display: table;
                    margin: 50px 0px;
                    .SectionTitle {
                        display: none;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: block;
                                `,
                                css`
                                    display: block;
                                `,
                                css`
                                    display: block;
                                `,
                                null,
                                null,
                            ])}
                        h2 {
                            color: #0000fe;
                            font-weight: normal;
                            font-size: 35px;
                            margin: 0px !important;
                            display: inline-block;
                            background: white;
                            position: relative;
                            z-index: 8;
                            padding: 0px 15px 0px 10px;
                            line-height: 30px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        font-size: 25px;
                                    `,
                                    css`
                                        font-size: 25px;
                                    `,
                                    css`
                                        font-size: 25px;
                                    `,
                                    null,
                                    null,
                                ])}
                        }
                        &::after {
                            content: "";
                            height: 8px;
                            background: #0000fe;
                            width: 100%;
                            display: inline-block;
                            position: relative;
                            bottom: 26px;
                            z-index: 1;
                        }
                    }
                }
                .SectionTitle {
                    margin: 55px 0px 30px 0px;
                }
                #TestimonialTitle {
                    font-size: 70px;
                    line-height: 80px;
                    text-align: right;
                    border-right: 1px solid #0000ff;
                    padding-right: 25px;
                    display: table-cell;
                    color: #0000ff;
                    font-weight: bold;
                    vertical-align: middle;
                    width: 300px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ])}
                }
                .Testimonial {
                    margin: 40px 5px;
                    background: whitesmoke;
                    padding: 5px;
                    p {
                        font-style: italic;
                        color: #0000fe;
                    }
                }
            }
            .ValuesImageRight {
                float: right;
                img {
                    max-width: 320px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            float: none;
                            text-align: center;
                            margin-bottom: 8px;
                            img {
                                max-width: 280px;
                            }
                        `,
                        css`
                            float: none;
                            text-align: center;
                            margin-bottom: 8px;
                            img {
                                max-width: 280px;
                            }
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .CoreValue {
                overflow: hidden;
                margin: 10px 0px 25px 0px;
            }
            .ValuesImageLeft {
                float: left;
                margin: 0px 15px 15px 15px;
                img {
                    max-width: 320px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            float: none;
                            text-align: center;
                            margin-bottom: 8px;
                            img {
                                max-width: 280px;
                            }
                        `,
                        css`
                            float: none;
                            text-align: center;
                            margin-bottom: 8px;
                            img {
                                max-width: 280px;
                            }
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
            .PageHeader.fundamentals {
                img {
                    display: none;
                }
                background-size: cover !important;
                width: 100%;
                height: 350px;
                background-position-x: 28% !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            background-position-x: 24% !important;
                        `,
                        css`
                            background-position-x: 24% !important;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
};

export const staticPageContainerStyles = styles;

const StaticPageContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} className="staticContainer">
            <Zone contentId={id} zoneName="content" />
        </StyledWrapper>
    );
};

const staticPageContainer: WidgetModule = {
    component: StaticPageContainer,
    definition: {
        group: "Common",
    },
};

export default staticPageContainer;
